var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKitchenScale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 8C3.89543 8 3 8.89543 3 10V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V10C21 8.89543 20.1046 8 19 8H5ZM17 15C17 17.7614 14.7614 20 12 20C9.23858 20 7 17.7614 7 15C7 12.2386 9.23858 10 12 10C14.7614 10 17 12.2386 17 15ZM11.5731 13.5616L12 11L12.4269 13.5616C13.0474 13.7455 13.5 14.3199 13.5 15C13.5 15.8284 12.8284 16.5 12 16.5C11.1716 16.5 10.5 15.8284 10.5 15C10.5 14.3199 10.9526 13.7455 11.5731 13.5616Z",
    fill: "#32D5D8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9994 6V8H9.99939V6H7.80216C6.67589 6 5.62413 5.43712 4.99939 4.5L4.51762 3.77735C4.36445 3.54759 4.42653 3.23715 4.6563 3.08397C4.73843 3.02922 4.83493 3 4.93365 3L19.0651 3C19.3413 3 19.5651 3.22386 19.5651 3.5C19.5651 3.59871 19.5359 3.69522 19.4812 3.77735L18.9994 4.5C18.3746 5.43712 17.3229 6 16.1966 6H13.9994Z",
    fill: "#32D5D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKitchenScale);
export default __webpack_public_path__ + "static/media/kitchen-scale.1a0297a44a4f64a534f62aaca473834b.svg";
export { ForwardRef as ReactComponent };